<template>
  <div>
    <Header/>
    <b-card class="bCardGlobalXL">
      <b-row class="divSubtitulo m-1 mb-3">
        <b-col cols="6" md="8">
          <div>
            <p class="textoSubtitulo">Catálogo de Laboratorios</p>
          </div>
        </b-col>
        <b-col cols="6" md="4">
          <div>
            <p style="text-align: end" class="textoSubtitulo">Catalogo_conf Lab</p>
          </div>
        </b-col>
      </b-row>


        <div class="d-flex justify-content-center w-100 mt-4">
          <div class="busqueda d-flex mt-4" style="width: 50%; margin-top: 10px;" >
            <b-form-input class="input-filter"
                          v-model="busqueda"
                          placeholder="Búsqueda de Laboratorio"
                          type="text"
                          v-on:keypress="esLetra($event)"
                          @keydown.enter.prevent="filtrarLaboratorio()"
            >
            </b-form-input>
            <b-button class="btn-extra-small" variant="info">
              <span ><em class="buscar_svg" style="margin-top: 3px; height: 13px; border-radius: 20px;" @click="filtrarLaboratorio()"></em></span>
            </b-button>
          </div>
          <div style="margin-left: 6px;">
            <em class="labs_svg"
                style="height: 36px; border-radius: 20px; margin-top: 23px; cursor: pointer"
                @click="agregarNuevo()"
                v-b-tooltip.hover.topright.v-light
                title="Agregar nuevo laboratorio"
                v-if="$localStorageService.can('laboratorios_lab_nuevo')"
            ></em>
          </div>
        </div>

      <div class="col-12 mt-5">
<!--        <br>-->
        <b-row class="contenedorTablaSinColor">
          <b-col sm="12" md="12" lg="12">
            <b-table
                id="labs"
                class="parrafos"
                fixed
                :fields="headersTabla"
                :items=" mostrarFiltrada ? listaFiltrada : listaLaboratorios "
                :per-page="15"
                :current-page="paginaActual"
                responsive
                thead-tr-class="columnasTablaSinColor"
                caption-top
            >
              <template #cell(flujoDigital)="row">
                <div style="font-size: 28px">
                <b-icon v-if="row.item.flujoDigital" size="lg" style="font-size: 28px;" icon="check" variant="success" ></b-icon>
                <b-icon v-else size="lg" style="font-size: 28px;" icon="x" variant="danger"></b-icon>
                </div>
              </template>
              <template #cell(Acciones)="row">
                <div class="text-center">

                  <em v-if="row.item.registroActivo && $localStorageService.can('laboratorios_lab_editar')" class= "edit_outline_svg" style="width: 21px; cursor: pointer"
                      @click="editarLab(row.item);"
                      v-b-tooltip.hover.topleft.v-light
                      title="Editar"
                  ></em>
                  <em v-else-if="$localStorageService.can('laboratorios_lab_inactivar')" class= "activar_kit" style="width: 21px; cursor: pointer"
                      @click="cambiarEstatus(row.item)"
                  ></em>

                  <em  v-if="row.item.registroActivo && $localStorageService.can('laboratorios_lab_inactivar')" class= "trash_svg" style="margin-left: 4px; cursor: pointer"
                       v-b-tooltip.hover.topright.v-light
                       title="Inactivar"
                       @click="cambiarEstatus(row.item)"
                  ></em>
                </div>
              </template>

            </b-table>
            <b-spinner v-if="cargando" variant="info" small/>
            <b-pagination
                v-if="listaLaboratorios.length > 15"
                v-model="paginaActual"
                :per-page="15"
                :total-rows="listaLaboratorios.length"
                align="center"
                size="sm"
                class="my-2"
            />
          </b-col>
        </b-row>
      </div>

    </b-card>


    <b-modal v-model="abrirModal" size="xl" hide-footer hide-header no-close-on-backdrop no-close-on-esc >
      <div class="row">
        <div class="col-10 d-flex" style="color: #044169; margin-top: -4px; font-weight: 600; width: 90%">
          <em class="laboratorio_svg" style="height: 60%; margin-top: 5px"></em>
          <span class="textSize ml-2" style="font-weight: 600;margin-top: 5px;" v-if="!editar">Nuevo Laboratorio</span>
          <span class="textSize ml-2" style="font-weight: 600;margin-top: 5px;" v-else-if="nombreLaboratorio != null">Editar {{nombreLaboratorio}} </span>
        </div>
        <div class="col-2 text-right">
          <em class="close_equis_svg" style="width: 12%; cursor: pointer" @click="hideModal()"
              v-b-tooltip.hover.topright.v-light
              title="Cerrar"
          />
        </div>
      </div>


      <b-tabs v-model="indexTab" nav-class="border-0" class="md-transparent" v-if="mostrarMenu">
        <template v-for="(pest, index) in pestaniasLab" >
          <b-tab lazy
                title-link-class="border-0"
                style="font-size: 14px;"
                :key="pest.id"
                :title="pest.nombre"
                v-if=" pest.permiso !== undefined
                            ? $localStorageService.can(pest.permiso)
                            : true  "
                class="borderGray paddingTab"
                :disabled=" (index === 1 || index === 2 || index === 3 ) && idLaboratorio === null"
          >
            <template #title>
              <span  style="font-size: 11px; pointer-events: none;cursor: default;"
                     :style="indexTab === index ? 'color: #0069A9;' : 'color: #212121;  '"
              >{{ pest.nombre }} </span>
              <div v-if="indexTab === index" class="linea"></div>
            </template>
          </b-tab>
        </template>
      </b-tabs>

      <b-card-body class="p-2">
        <div v-show="indexTab === 0">
          <InformacionGeneralLab
              ref="informacionLabGeneral"
              id="informacionLabGeneral"
              :listaTipoFlujoFisico="listaTipoFlujoFisico"
              :listaEstados="listaEstados"
              :idLaboratorio="idLaboratorio"
              :informacionGeneral="informacionGeneral"
              :editar="editar"
              @obtenerLaboratorios="obtenerLaboratorios"
              :listaColorimetros="listaColorimetros"
          />
        </div>
        <div v-show="indexTab === 1">
          <ClinicasLab
              :listaClinicas="listaClinicas"
              :idLaboratorio="idLaboratorio"
              :clinicasLab="clinicasLab"
              :editar="editar"
              @obtenerLaboratorios="obtenerLaboratorios"
          />
        </div>
        <div v-show="indexTab === 2">
          <ProductosLab
              :listaTratamientos="listaTratamientos"
              :idLaboratorio="idLaboratorio"
              :editar="editar"
              @obtenerLaboratorios="obtenerLaboratorios"
              :productosLab="productosLab"
          />
        </div>
        <div v-show="indexTab === 3">
          <UsuarioLab
              @ocultarMenu="ocultarMenu()"
              @obtenerLaboratorios="obtenerLaboratorios"
              :idLaboratorio="idLaboratorio"
              :usuariosLabProps="usuariosLab"
          />
        </div>
      </b-card-body>
    </b-modal>


  </div>
</template>

<script >
import Header from "@/components/Header.vue";
import InformacionGeneralLab from "@/views/catalogos/Laboratorio/Laboratorios/InformacionGeneralLab.vue";
import ClinicasLab from "@/views/catalogos/Laboratorio/Laboratorios/ClinicasLab.vue";
import ProductosLab from "@/views/catalogos/Laboratorio/Laboratorios/ProductosLab.vue";
import UsuarioLab from "@/views/catalogos/Laboratorio/Laboratorios/UsuarioLab.vue";

export default {
  name: "Laboratorios",
  components: {UsuarioLab,  ProductosLab, ClinicasLab, InformacionGeneralLab, Header },
  data: () => ({
    busqueda: null,
    mostrarFiltrada: false,
    headersTabla: [
      {key: "idLaboratorio", label: "ID LABORATORIO", sortable: false},
      {key: "nombreLab", label: "Nombre", sortable: false},
      {key: "totalProductos", label: "Productos", sortable: false},
      {key: "flujoDigital", label: "Flujo Digital", sortable: false},
       "Acciones"
    ],
    indexTab: 0,
    paginaActual:1,
    pestaniasLab: [
      { id: 1, nombre: "Información general", identificadorTab:"infoGeneral", visible: false, layoutTabla: [], /* permiso: ""*/ },
      { id: 2, nombre: "Clínicas", identificadorTab:"clinicas", visible: false, layoutTabla: [], /* permiso: ""*/ },
      { id: 3, nombre: "Productos", identificadorTab: "productos", visible: false, layoutTabla: [], /* permiso: ""*/ },
      { id: 4, nombre: "Usuarios", identificadorTab: "usuario", visible: false, layoutTabla: [], /* permiso: ""*/ },
    ],
    listaClinicas: [],
    listaTipoFlujoFisico: [],
    listaEstados: [],
    listaLaboratorios: [],
    listaFiltrada: [],
    listaTratamientos: [],
    informacionGeneral: null,
    abrirModal: false,
    editar: false,
    idLaboratorio: null,
    clinicasLab: [],
    productosLab: [],
    listaColorimetros: [],
    usuariosLab: [],
    nombreLaboratorio: null,
    cargando: false,
    mostrarMenu: true,
  }),
  created() {
    this.obtenerCatalogos();
  },
  methods: {
    filtrarLaboratorio(){
      if (this.busqueda.trim().length >= 1){
        this.mostrarFiltrada = true;
        this.listaFiltrada = this.listaLaboratorios.filter(lab =>
            lab.nombreLab.toLowerCase().includes(this.busqueda.toLowerCase())
        );
      }else {
        this.mostrarFiltrada = false;
      }

    },
    obtenerCatalogos() {
      this.obtenerClinicas();
      this.obtenerTiposFlujoFisico();
      this.obtenerEstados();
      this.obtenerLaboratorios(10)
      this.obtenerTratamientos();
      this.obtenerColorimetros();
      this.indexTab = 0;
    },
    ocultarMenu(){
      this.mostrarMenu = !this.mostrarMenu
    },
    editarLab(item) {

      this.nombreLaboratorio = item.nombreLab
      this.editar = true;
      this.idLaboratorio = item.idLaboratorio;
      this.informacionGeneral = item.informacionGeneralLab;
      this.clinicasLab = item.clinicasLab;
      this.productosLab = item.productosLab;
      this.usuariosLab = item.usuariosLab;

      this.abrirModal = true
      this.indexTab = 0;

    },
    obtenerClinicas() {
      this.$http.get(this.$api + "catalogos/getClinicas")
          .then((response) => {
            this.listaClinicas = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          }).finally(() => {
      });
    },
    obtenerColorimetros() {
      this.$http.get(this.$api + "labs/colorimetros/labs")
          .then((response) => {
            this.listaColorimetros = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          }).finally(() => {
      });
    },

    obtenerLaboratorios(index, idLaboratorio){
      //this.hideModal();
      index === 10 ? this.indexTab = 0 : this.indexTab = index;

        this.idLaboratorio = idLaboratorio != null || idLaboratorio != undefined ? idLaboratorio : this.idLaboratorio


        this.cargando = true;
        if (index === 4){
          this.hideModal();
        }
        this.listaLaboratorios = [];
        this.paginaActual = 1


        this.$http.get(this.$api + "labs/listarLaboratorios")
          .then((response) => {
            this.cargando = false;
            this.listaLaboratorios = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          }).finally(() =>{});

    },

    cambiarEstatus(item){
      this.$swal.fire({
        icon: "warning",
        html: '<p><strong>¿Estás seguro?</strong></p>',
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        confirmButtonColor: "#EEBA6D",
        preConfirm: () => {
          const guardar = {
            idLaboratorio: item.idLaboratorio
          }
          this.$http.post(this.$api + "labs/cambiarEstatus/laboratorio", guardar).then((response) => {
            if (response.data.data){
              this.$swal({
                icon: "success",
                text: "Se guardó correctamente la información ",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
                onClose: () => {
                  item.registroActivo = !item.registroActivo
                  // this.obtenerLaboratorios(10);
                }
              })
            }
          })
        }
        })

    },
    obtenerEstados() {
      this.$http
          .get(this.$api + "catalogos/listaEstados")
          .then((response) => {
            this.listaEstados = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          }).finally();
    },
    obtenerTiposFlujoFisico(){
      this.$http.get(this.$api + "labs/listaFlujoFisico")
          .then((response) => {
            this.listaTipoFlujoFisico = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          }).finally(() =>{});
    },
    obtenerTratamientos(){
      this.$http.get(this.$api + "catalogos/obtenerTratamientosActivos")
          .then((response) => {
            this.listaTratamientos = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          }).finally(() =>{});
    },
    agregarNuevo() {
      this.abrirModal = true;
      this.editar = false;
      this.idLaboratorio = null;


      this.$swal({
        icon: "info",
        html: '<p><strong>Para agregar clínicas y productos, primero debe guardar la "información general" del laboratorio.</strong></p>',
        showConfirmButton: false,
        timerProgressBar: true,
        timer: 5000,
      });

    },
    hideModal() {
      this.mostrarMenu = true;
      this.indexTab = 0;
      this.abrirModal = false;
      this.editar = false;
    },

    esLetra(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },

  }
}

</script>

<style scoped>
.busqueda {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  margin-top: 20px;
  margin-left: 4%;
  padding-right: 2%;
  padding-left: 1%;
  border-radius: 20px;
  text-align: left;
  align-items: center;
}
.textSize {
  font-size: 0.8em;
}
.linea {
  border-top: 2px solid #0069A9 !important;
  height: 2px;
  max-width: 60px;
  padding: 0;
  margin: auto;
  background-color: white;
}
.b-tabs {
  pointer-events: none;
}
</style>